import Lenis from "@studio-freight/lenis";

// Single Lenis instance; light, natural feel. Disabled on fullscreen/app-like routes.
let lenis = null;
let raf = 0;
const NO_SMOOTH_RE = /^\/(map|admin)(\/|$)/;

export function initLenis() {
  if (lenis || window.matchMedia("(pointer: coarse)").matches) return; // native touch scrolling on mobile
  lenis = new Lenis({ duration: 0.85, smoothWheel: true, smoothTouch: false, syncTouch: false, wheelMultiplier: 1, lerp: 0.12 });
  const loop = (time) => { lenis?.raf(time); raf = requestAnimationFrame(loop); };
  raf = requestAnimationFrame(loop);
}

export function destroyLenis() {
  cancelAnimationFrame(raf);
  lenis?.destroy();
  lenis = null;
}

export function syncLenisRoute(pathname, hash) {
  document.documentElement.classList.toggle("no-smooth", NO_SMOOTH_RE.test(pathname));
  if (!lenis) { if (!hash) window.scrollTo(0, 0); return; }
  if (NO_SMOOTH_RE.test(pathname)) lenis.stop(); else lenis.start();
  if (!hash) lenis.scrollTo(0, { immediate: true });
  else setTimeout(() => { const el = document.querySelector(hash); if (el) lenis.scrollTo(el, { offset: -90 }); }, 250);
}

export function releaseScroll() {
  // Ensure nothing leaves the page locked after dialogs / overlays close
  document.body.style.removeProperty("overflow");
  document.body.style.removeProperty("pointer-events");
  lenis?.start();
}

export const getLenis = () => lenis;
